var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 mb-4"},[_c('div',{staticClass:"mb-3 mt-4",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',[_c('v-btn',{staticClass:"pa-4",attrs:{"icon":"","color":"primary","to":"/weserve_admin_login/-/reportdashboard/main"}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("arrow_back")])],1)],1),_c('span',{staticClass:"main-title"},[_vm._v("MAIN DASHBOARD |  ")]),_c('span',{staticClass:"submain-title"},[_vm._v("Reward Report")])]),_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('download-excel',{staticStyle:{"margin-right":"50px"},attrs:{"data":_vm.export_reward_format,"fields":{
          No: 'No',
          Name: 'campaign_name',
          Category: 'campaign_service_type',
          Amount: 'amount',
          'Used/Cancel': 'used',
          'Value price(THB)': 'total_value_price',
          'Paid price(THB)': 'total_paid_price',
        },"name":'RewardReport_' +
            _vm.search_config.datetime_start +
            '_to_' +
            _vm.search_config.datetime_end +
            '.xls'}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".xls ")],1)],1),_c('download-excel',{attrs:{"type":"csv","data":_vm.export_reward_format,"fields":{
          No: 'No',
          Name: 'campaign_name',
          Category: 'campaign_service_type',
          Amount: 'amount',
          'Used/Cancel': 'used',
          'Value price(THB)': 'total_value_price',
          'Paid price(THB)': 'total_paid_price',
        },"name":'RewardReport_' +
            _vm.search_config.datetime_start +
            '_to_' +
            _vm.search_config.datetime_end +
            '.csv'}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".csv ")],1)],1)],1)]),_c('searchDateStartToEnd',{attrs:{"searching":_vm.searching,"action_method":"report","province":true},on:{"search":function($event){return _vm.searchList()}}}),_c('rewardReportList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }